const CONFIG = {
    RECAPTCHA_KEY:process.env.RECAPTCHA_KEY || "6LehSUwpAAAAADddojB8E4t6R1Q2DSR9xfHhmeEh",
    GOOGLE_MAP_KEY:process.env.GOOGLE_MAP_KEY || "AIzaSyCUMVJzwgpyE-hqQubtSKolVELRdYJcnJ0",
}
export default CONFIG